/**
 * k线图BOLL线装饰器
 */
import {
  LINE_TYPE
} from '../../../viewmodel/setting.js';
import Util, {mergeModelData, curryFun} from '../../../util/index.js';
const model = {
  bollData: {
    Type: Object,
    Default: () => ({})
  }
};
const KLineBOLLDectorator = BaseClass => class extends BaseClass {
  constructor({data, ...rest}) {
    super({...rest, data: mergeModelData(model, data)});
  }
  _calcRange() {
    super._calcRange();
    const {upper, lower, mid} = this.state.data.bollData;
    this.calcRange({data: [upper, lower, mid], targetKey: 'value', isAdditional: true})
  }
  _calcAxis() {
    super._calcAxis();
    const {upper, lower, mid} = this.state.data.bollData;
    const curryCalcAxis = curryFun(this.calcAxis, this, {
      targetKey: 'value',
      sourceKey: 'lineY',
      isAdditional: true,
    });
    curryCalcAxis({data: upper});
    curryCalcAxis({data: lower});
    curryCalcAxis({data: mid});
  }
  _drawMain() {
    super._drawMain();
    const {
      left,
      width,
      bottom,
    } = this.availArea;
    const {upper:UPPER = [], lower:LOWER = [], mid:MID = []} = this.state.data.bollData;
    const {LINE} = LINE_TYPE;
    const {upper, lower, mid} = this.option.BOLL;
    this._drawLine(LINE, UPPER, left, bottom, upper.lineWidth, upper.color);
    this._drawLine(LINE, LOWER, left, bottom, lower.lineWidth, lower.color);
    this._drawLine(LINE, MID, left, bottom, mid.lineWidth, mid.color);
  }
  _drawTitle() {
    const ctx2 = this.curContext;
    const {current, sealObj} = this.state.data;
    const {height, top, baseSize} = this.state;
    const {ratioFixed} = sealObj;
    const {space} = this.option.BOLL;
    const {baseLine} = this.option.MainContext.title;
    const baseLineY = top + height * baseLine;
    let {left} = this.availArea;
    [
      'upper',
      'mid',
      'lower'
    ].forEach((val, index) => {
      const data = this.state.data.bollData[val]
      const {
        sizeRatio,
        fontFamily,
        color,
      } = this.option.BOLL[val];
      ctx2.font = sizeRatio * baseSize * this.dpr + 'px ' + fontFamily;
      ctx2.fillStyle = color;
      ctx2.textAlign = 'left';
      ctx2.textBaseline = 'middle';
      ctx2.beginPath();
      const item = data[current];
      if (Util.isDef(item) && Util.isValidNumber(item.value)) {
        const text = val.toUpperCase() + ': ' + item.value.toFixed(ratioFixed);
        const textWidth = ctx2.measureText(text).width;
        ctx2.fillText(text, left, baseLineY);
        left += textWidth;
      } else {
        const text = val.toUpperCase() + ': -';
        const textWidth = ctx2.measureText(text).width;
        ctx2.fillText(text, left, baseLineY);
        left += textWidth;
      }
      left += space * this.dpr;
    })
  }
}
export default KLineBOLLDectorator;